"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//

var breakpoints = {
  xs: 0,
  // mobile
  sm: 576,
  // mobile landscape
  md: 768,
  // tablets
  lg: 992 // Wide

};
var _default = breakpoints;
exports["default"] = _default;